import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PessoaService } from 'src/app/services/pessoa.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UtilsService } from 'src/app/utils/utils.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cadastro-senha-fornecedor',
  templateUrl: './cadastro-senha-fornecedor.component.html',
  styleUrls: ['./cadastro-senha-fornecedor.component.scss']
})
export class CadastroSenhaFornecedorComponent implements OnInit {
  email: string = '';
  login: string = '';
  senha: string = '';
  confirmaSenha: string = '';
  carregando: boolean = false;
  token: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pessoaService: PessoaService,
    private usuarioService: UsuarioService,
    private utils: UtilsService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    // Obter token da rota
    this.route.params.subscribe(params => {
      if (params['token']) {
        this.token = params['token'];
        this.validarToken();
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  validarToken() {
    this.carregando = true;
    this.usuarioService.validarToken(this.token).subscribe(
      res => {
        this.carregando = false;
        if (res && res.email) {
          this.email = res.email;
        } else {
          // Token inválido
          Swal.fire('Atenção', 'Token inválido ou expirado', 'error').then(() => {
            this.router.navigate(['/login']);
          });
        }
      },
      err => {
        this.carregando = false;
        // Token inválido
        Swal.fire('Atenção', 'Token inválido ou expirado', 'error').then(() => {
          this.router.navigate(['/login']);
        });
      }
    );
  }

  cadastrar() {
    // Validações
    if (!this.login || !this.senha || !this.confirmaSenha) {
      Swal.fire('Atenção', this.translate.instant('PREENCHA_TODOS_OS_CAMPOS'), 'warning');
      return;
    }

    if (this.senha.length < 6) {
      Swal.fire('Atenção', this.translate.instant('SENHA_MINIMO_6_CARACTERES'), 'warning');
      return;
    }

    if (this.senha !== this.confirmaSenha) {
      Swal.fire('Atenção', this.translate.instant('SENHAS_NAO_CONFEREM'), 'warning');
      return;
    }

    this.carregando = true;

    const dados = {
      email: this.email,
      login: this.login,
      senha: this.senha,
      token: this.token
    };

    this.usuarioService.criarSenhaFornecedor(dados, this.token).subscribe(
      res => {
        this.carregando = false;
        Swal.fire(this.translate.instant('SUCESSO'), this.translate.instant('CADASTRO_REALIZADO_COM_SUCESSO'), 'success').then(() => {
          this.router.navigate(['/login']);
        });
      },
      err => {
        this.carregando = false;
        this.utils.getErro(err);
      }
    );
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.cadastrar();
    }
  }
}
